(ns admin.components.composite.activity-overview
  (:require
   [potpuri.core :as pot]
   [kyber.components.base.text :as text]
   [kyber.components.composite.progress-bar :as progress-bar]
   [kyber.styles.core :refer [gs styles->classes]]
   [kyber.utils :as ku]
   [admin.components.composite.activity-overview.step-card :refer [step-card]]))

(def classes
  (styles->classes
   {:flex-center-row
    {:display :flex
     :flex-direction :row
     :justify-content :center
     :align-items :center}

    :activity-design-progress
    {:display :flex
     :align-items :center
     :border-bottom (str "1px solid " (gs [:colors :gray-scale-100]))
     :margin-bottom (gs [:spacing :p20])
     :padding (gs [:spacing :p20])}

    :activity-design-progress-text
    {:white-space :nowrap
     :padding-right (gs [:spacing :p8])}

    :fraction-text
    {:padding-left (gs [:spacing :p8])}

    :overview-cards-container
    {:display :flex
     :flex-direction :column
     :width "100%"}}))

(defn- render-activity-readiness
  [{:keys [points-available points-awarded]}]
  (let [percentage (ku/calc-percent points-available points-awarded)]
    [:div {:class (:activity-design-progress classes)}
     [text/title-20 :p {:class (:activity-design-progress-text classes)}
      "Activity Design Quality Score"]
     [progress-bar/render
      {:percent-filled percentage
       :styles {:height (gs [:spacing :p32])}}]
     [text/title-20 :p {:class (:fraction-text classes)}
      (str (ku/calc-percent-rounded points-available points-awarded)
           "/"
           100)]]))

(defn render
  [{:keys [activity curriculum overview-details]}]
  [:div
   [render-activity-readiness {:points-available
                               (:points-available overview-details)
                               :points-awarded
                               (:points-awarded overview-details)}]
   [:div {:class (:overview-cards-container classes)}
    (for [step (map-indexed #(assoc %2 :step-index (inc %1)) (:steps overview-details))]
      ^{:key step}
      [step-card (pot/map-of step activity curriculum)])]])
